import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const labelVariants = cva('text-sm font-semibold text-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70', {
  variants: {
    disabled: {
      true: 'text-neutral-light'
    },
    customFileInput: {
      true: 'block cursor-pointer [&_input]:hidden'
    }
  },
  defaultVariants: {
    disabled: false,
    customFileInput: false
  }
});

const Label = React.forwardRef(({ className, disabled, customFileInput, asChild = false, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants({ disabled, customFileInput }), className)}
    asChild={asChild}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
